export const tzIdentifiers = [
	'America/New_York',
	'America/Toronto',
	'America/Phoenix',
	'America/Chicago',
	'Australia/Melbourne',
	'Australia/Sydney',
	'Europe/Dublin',
	'Europe/London',
	'Pacific/Auckland',
	'UTC',
] as const;
